import type { ReactNode } from "react";
import { Pill, type PillTone } from "../ui/Pill";
import { Tooltip } from "../ui/Tooltip";

export function ScorePill({
  score,
  tooltip,
}: {
  score: number | null;
  tooltip?: ReactNode;
}) {
  if (score === null) {
    return <Pill tone="neutral">Unscored</Pill>;
  }
  const tone: PillTone = score >= 8 ? "success" : score >= 6 ? "warning" : "neutral";
  const pill = (
    <Pill tone={tone} variant="solid" className="tabular-nums">
      {score.toFixed(1)}
    </Pill>
  );
  if (!tooltip) return pill;
  return (
    <Tooltip label={tooltip}>
      <span>{pill}</span>
    </Tooltip>
  );
}
